import { useCallback, useMemo, useState } from "react";

import { type FooterConfig, getFooterLinks } from "../../../config";
import { useModal } from "../../../elements";
import { getLinkTarget as getLinkTargetUtil } from "../footer.utils";
import { FooterContext } from "./footer.context";

import type { MouseEvent, ReactNode } from "react";

export type FooterProvidersProps = {
  baseURL: string;
  children: ReactNode;
  customLinks?: FooterConfig;
  shouldOpenInSameWindow?: boolean;
};

export function FooterProvider({
  baseURL,
  customLinks,
  children,
  shouldOpenInSameWindow = false,
}: Readonly<FooterProvidersProps>) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const links = customLinks ?? getFooterLinks(baseURL);
  const { openModal } = useModal("CookieControlModal");

  const handleFooterLinkClick = useCallback(
    (event: MouseEvent<HTMLElement>, id: string) => {
      if (id === "footer_institutional_cookiesManagement") {
        event.preventDefault();
        openModal();
      }
    },
    [openModal]
  );

  const getLinkTarget = useCallback(
    (url: string | undefined) =>
      getLinkTargetUtil(url, shouldOpenInSameWindow),
    [shouldOpenInSameWindow]
  );

  const providerValue = useMemo(
    () => ({
      links,
      isExpanded,
      setIsExpanded,
      handleFooterLinkClick,
      getLinkTarget,
    }),
    [links, isExpanded, handleFooterLinkClick, getLinkTarget]
  );

  return (
    <FooterContext.Provider value={providerValue}>
      {children}
    </FooterContext.Provider>
  );
}
